import React from 'react';
import ReactTags from 'react-tag-autocomplete';

// suggestionComponent example copied from the README because the standard looks horrible when not having any query.
const SuggestionComponent = ({item, query}) => {
  return (
    <span id={item.id} className={item.name === query ? 'match' : 'no-match'}>
      {item.name}
    </span>
  );
};

const TagSuggestions = (props) => {
  return (
    <ReactTags
      // Directly pass any props directly to the component, while overriding the ones we want afterwards, like the suggestion component.
      {...props}
      suggestionComponent={SuggestionComponent}
    />
  );
};

export default TagSuggestions;
